import React, { createContext, useCallback, useContext, useRef, useState } from "react";
import styles from "../components/Login/LoginSuccessAnimation/LoginSuccessAnimation.module.scss";

interface TransitionContextType {
  playTransition: (onNavigate: () => void) => void;
}

const TransitionContext = createContext<TransitionContextType | null>(null);

export const TransitionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const navCallbackRef = useRef<(() => void) | null>(null);

  const playTransition = useCallback((onNavigate: () => void) => {
    navCallbackRef.current = onNavigate;
    setVisible(true);

    // A 1s: naviga (la dashboard carica dietro l'overlay che sfuma)
    setTimeout(() => {
      navCallbackRef.current?.();
    }, 1000);

    // A 1.8s: smonta l'overlay
    setTimeout(() => {
      setVisible(false);
      navCallbackRef.current = null;
    }, 1800);
  }, []);

  return (
    <TransitionContext.Provider value={{ playTransition }}>
      {children}
      {visible && (
        <div className={styles.overlay}>
          <div className={styles.ring} />
          <div className={styles.logoWrap}>
            <svg className={styles.logo} viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M384.915 279.467C380.946 290.65 367.108 294.374 356.217 288.255C345.48 282.222 342 268.7 344.925 256.565C345.658 253.524 346.212 250.434 346.583 247.309C347.889 236.299 346.891 225.072 343.651 214.271C340.411 203.47 334.993 193.306 327.709 184.359C320.426 175.412 311.419 167.854 301.204 162.115C290.989 156.375 279.763 152.565 268.167 150.902C256.571 149.238 244.828 149.753 233.608 152.42C222.388 155.087 211.909 159.855 202.772 166.455C200.178 168.328 197.708 170.339 195.369 172.476C186.016 181.024 172.201 184.865 161.444 178.82C150.573 172.713 146.983 159.245 154.939 150.319C160.853 143.685 167.52 137.67 174.842 132.381C188.543 122.484 204.269 115.325 221.123 111.319C237.978 107.312 255.63 106.536 273.07 109.038C290.51 111.54 307.395 117.271 322.758 125.903C338.121 134.535 351.659 145.897 362.601 159.338C373.543 172.779 381.673 188.035 386.531 204.231C391.389 220.428 392.881 237.249 390.925 253.735C389.88 262.545 387.861 271.168 384.915 279.467ZM112.52 221.822C116.49 210.639 130.328 206.915 141.219 213.034C151.956 219.067 155.436 232.589 152.511 244.724C151.778 247.765 151.224 250.855 150.853 253.979C149.547 264.99 150.544 276.217 153.784 287.018C157.024 297.819 162.443 307.983 169.726 316.93C177.01 325.877 186.017 333.435 196.232 339.174C206.447 344.914 217.672 348.724 229.269 350.387C240.865 352.051 252.608 351.536 263.828 348.869C275.048 346.202 285.527 341.434 294.664 334.834C297.257 332.96 299.728 330.95 302.066 328.813C311.42 320.265 325.234 316.424 335.992 322.468C346.862 328.576 350.453 342.044 342.497 350.97C336.583 357.604 329.916 363.619 322.594 368.908C308.893 378.805 293.167 385.964 276.312 389.97C259.458 393.977 241.806 394.753 224.366 392.251C206.925 389.749 190.041 384.018 174.678 375.386C159.315 366.754 145.777 355.392 134.835 341.951C123.893 328.509 115.763 313.254 110.905 297.058C106.047 280.861 104.555 264.04 106.51 247.554C107.556 238.744 109.575 230.121 112.52 221.822ZM248.718 300.902C220.961 300.902 198.46 278.401 198.46 250.644C198.46 222.888 220.961 200.387 248.718 200.387C276.474 200.387 298.976 222.888 298.976 250.644C298.976 278.401 276.474 300.902 248.718 300.902Z"
                fill="#063444"
              />
            </svg>
          </div>
        </div>
      )}
    </TransitionContext.Provider>
  );
};

export const useTransition = () => {
  const ctx = useContext(TransitionContext);
  if (!ctx) throw new Error("useTransition must be used within TransitionProvider");
  return ctx;
};
